function SmallArrowDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      fill="none"
      viewBox="0 0 17 17"
    >
      <g clipPath="url(#clip0_696_3176)">
        <path
          stroke="#21272A"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.333"
          d="M4.5 10.07l4-4 4 4"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_696_3176">
          <path
            fill="#fff"
            d="M0 0H16V16H0z"
            transform="matrix(1 0 0 -1 .5 16.07)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default SmallArrowDown;